import { ObjectDataset } from "@tblabs/storage";
import { Collection, RefNumber } from "@tblabs/truffle";
import { Expanse } from "../../Models/Expanse";


export class ExpansesProvider
{
    private items: Collection<Expanse> = new Collection<Expanse>();
    private sum = new RefNumber();

    public get Items(): Collection<Expanse>
    {
        return this.items;
    }


    public get Sum(): RefNumber
    {
        return this.sum;
    }

    constructor(private _expansesRepo: ObjectDataset<Expanse[]>)
    { }

    private RecalcSum(): void
    {
        // this.items.Items.forEach(e =>
        // e.Amount.OnChange((_) =>
        this.sum.value = this.items.Items.reduce((acc, x) => acc + x.Amount.value, 0);
        // , true));
    }

    public async GetAll(): Promise<Collection<Expanse>>
    {
        const expanses: Expanse[] = await this._expansesRepo.GetOne("Expanses");
        this.items.Load(...expanses);
        this.RecalcSum();
        return this.items;
    }

    public async Add(expanse: Expanse): Promise<void>
    {
        this.items.Add(expanse);
        this.RecalcSum();
        await this.Save();
    }

    public async Remove(expanse: Expanse): Promise<void>
    {
        this.items.Remove(expanse);
        this.RecalcSum();
        await this.Save();
    }

    public async Save(): Promise<void>
    {
        await this._expansesRepo.Update("Expanses", this.items.Items);
    }
}
